import { NavItem } from '../../nav/primitives/nav-item';
import { useFaxNavItem } from './use-fax-nav-item';

export const FaxNavItem = () => {
  const item = useFaxNavItem();
  return <NavItem item={item} />;
};
